import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UsefulHintsService {

  contentSubject: Subject<string> = new Subject();

  openSubject: Subject<any> = new Subject();

  closeSubject: Subject<any> = new Subject();

  private timeout: any;

  constructor() { 
    this.contentSubject.subscribe(() => this.openSubject.next(null));
    this.openSubject.subscribe(() => {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => this.closeSubject.next(null), 10000);
    });
  }

  say(message: string): void {
    this.contentSubject.next(message);
  }
}
